import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    offCanvasIsActive: false,
}

export const offCanvasSlice = createSlice({
    name: "active", //?
    initialState,
    reducers:{
        offCanvasReset: (state) => initialState,
        toggleOffCanvasIsActive: (state) =>{
            state.offCanvasIsActive = !state.offCanvasIsActive
        }
    },
})

export const { offCanvasReset, toggleOffCanvasIsActive} = offCanvasSlice.actions;
export default offCanvasSlice.reducer;